import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Header from "./components/common/header/Header";
import Footer from "./components/common/footer/Footer";
import Contact from "./pages/contact/Contact";
import About from "./pages/about/About";
import Destinations from "./pages/destinations/Destinations";
import PhotoGallery from "./pages/gallery/PhotoGallery";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about-us" element={<About />} />

        <Route path="contact-us" element={<Contact />} />

        <Route path="portfolio" element={<Destinations />} />
        <Route path="gallery" element={<PhotoGallery />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
